<app-page-header [pageTitle]="'Max Mustermann'"></app-page-header>

<div class="card-wrapper">
  <div class="card">
    <div class="card-body">
      <div id="timetable-months-table-wrapper" class="k-w-full">
        <app-shive-grid [grid]="grid">
          <kendo-grid
            #grid
            kendoGridSelectBy="id"
            scrollable="none"
            size="medium"
            [kendoGridBinding]="timeTableData$ | async"
            [pageSize]="20"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            [columnMenu]="{ filter: true }"
          >
            <ng-template kendoGridToolbarTemplate>
              <div class="k-d-flex k-align-items-center k-w-full k-justify-content-between">
                <h3 class="headline">Monatsauswertung</h3>
                <!-- Not really a form, but use k-form here to set the correct styling -->
                <div class="k-form">
                  <app-timetable-year-selection />
                </div>
              </div>
            </ng-template>

            <kendo-grid-checkbox-column
              [width]="60"
              [headerClass]="{ 'k-text-center': true }"
              [class]="{ 'k-text-center': true }"
              [resizable]="false"
              [columnMenu]="false"
              [showSelectAll]="true"
            ></kendo-grid-checkbox-column>

            <kendo-grid-column field="month" title="Monat">
              <ng-template kendoGridCellTemplate let-row>
                <span class="k-font-style-italic">{{ row.month }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="nominal" title="Soll-Arbeitszeit">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.nominalHours | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="actual" title="Ist-Arbeitszeit">
              <ng-template kendoGridHeaderTemplate let-headerText>
                <div>
                  <span class="k-font-semibold">{{ headerText.title }}</span>

                  <span #popupAnchor>
                    <a shivePopup [popupAnchor]="popupAnchor" [content]="template">
                      <fa-icon class="k-ml-2.5 turquoise" [icon]="faCircleInfo" size="lg"></fa-icon>
                    </a>
                  </span>
                </div>
              </ng-template>

              <ng-template kendoGridCellTemplate let-row>
                {{ row.actualHours | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="overtime" title="Abwesend (Arbeitszeit)">
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-flex">
                  {{ row.absent | date: "HH:mm" }}

                  @if (row.absent > 0) {
                    <span #popupAnchor>
                      <a shivePopup [popupAnchor]="popupAnchor" [content]="templateTwo">
                        <fa-icon
                          class="k-ml-2.5 turquoise"
                          [icon]="faCircleInfo"
                          size="lg"
                        ></fa-icon>
                      </a>
                    </span>
                  }
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="overtime" title="Übertrag Vormonat">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.overtimeLastMonth | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="sum" title="Summe">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.difference | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="overtime" title="Zeitausgleich">
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-flex">
                  {{ row.absent | date: "HH:mm" }}
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="overtime" title="Ausbezahlt">
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-flex">
                  {{ row.absent | date: "HH:mm" }}
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="result" title="Saldo" class="result">
              <ng-template kendoGridCellTemplate let-row>
                <span class="k-font-semibold">
                  <span
                    [class.positive]="row.result > 0"
                    [class.error-red]="row.result < 0"
                    [class.balanced]="row.result === 0"
                    >{{ row.result | date: "HH:mm" }}</span
                  >
                </span>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </app-shive-grid>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div style="margin: 15px; z-index: 2; text-wrap: balance">
    Entspricht der reinen Projektzeit ohne Abwesenheiten.
  </div>
</ng-template>

<ng-template #templateTwo>
  <div style="margin: 15px; z-index: 2">
    <div class="mb-2 k-font-weight-semibold">Abwesenheitsgründe</div>
    <ul class="k-m-0">
      <li>Krank (3 Tage)</li>
      <li>Urlaub (7 Tage)</li>
    </ul>
  </div>
</ng-template>
